import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatTaxTotal } from "./fulfillment-group-csv-utils";

export const TaxTotalCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Tax total", cell: (row) => formatTaxTotal(row) };
